export default __webpack_public_path__ + "static/media/happy60plus_icon-square.9e0a99f2.png";